import { render, staticRenderFns } from "./allocation_config_types.vue?vue&type=template&id=6beee4e2&scoped=true&"
import script from "./allocation_config_types.vue?vue&type=script&lang=js&"
export * from "./allocation_config_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beee4e2",
  null
  
)

export default component.exports